import { http } from '../http';
import { collectionSerializer } from '@/providers/serializers/content/collection';
import { resourceSerializer } from '@/providers/serializers/content/resource';
import { questionSerializer } from '@/providers/serializers/content/question';
import { contentSerializer } from '@/providers/serializers/content/content';
import { courseSerializer } from '@/providers/serializers/content/course';

// Class Hold all the collection content API
export class ContentAPI {

  private static INSTANCE = new ContentAPI();

  static get instance() {
    return this.INSTANCE;
  }

  private namespaceOa = 'api/nucleus/v2/oa';

  private namespace = 'api/nucleus/v1';

  private stubNamespace = 'stubs';

  private resourceNamespace = 'api/missioncontrol/v1/resource';


  /**
   * Reads a getMetadataLevel
   *
   * @returns {Promise}
   */
  public getMetadataLevel() {
    const url = `${window.location.origin}/${this.stubNamespace}/meta-data.json`;
    const headers = http.getTokenHeaders();
    return http.get(url, headers).then((response) => {
      return response.data;
    });
  }

  /**
   * Reads a resource by id
   *
   * @param {string} resourceId
   * @returns {Promise}
   */
  public getQuestionById(questionId: any) {
    const question = 'questions';
    const url = `${this.namespace}/${question}/${questionId}`;
    const headers = http.getTokenHeaders();
    return http.get(url, headers).then((response) => {
      return questionSerializer.normalizeQuestionContent(response.data);
    });
  }

  /**
   * Reads a resource by id
   *
   * @param {string} resourceId
   * @returns {Promise}
   */
  public getResourceById(resourceId: any) {
    const resource = 'resources';
    const url = `${this.namespace}/${resource}/${resourceId}`;
    const headers = http.getTokenHeaders();
    return http.get(url, headers).then((response) => {
      return resourceSerializer.normalizeResourceContent(response.data);
    });
  }

  /**
   * Reads a collection by id
   *
   * @param {string} collectionId
   * @returns {Promise}
   */
  public getCollectionById(collectionId: string) {
    const endpoint = `${this.namespace}/collections/${collectionId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });
  }

  /**
   * Reads a offline activity by id
   * @param {string} activityId
   * @returns {Promise}
   */
  public getActivityById(activityId: string) {
    const endpoint = `${this.namespaceOa}/${activityId}/detail`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });
  }

  public getCourseById(courseId: string) {
    const endpoint = `${this.namespace}/courses/${courseId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return courseSerializer.normalizeCourseContent(response.data);
    });
  }


  /**
   * Reads a assessment by id
   *
   * @param {string} assessmentId
   * @returns {Promise}
   */
  public getAssessmentById(assessmentId: string) {
    const endpoint = `${this.namespace}/assessments/${assessmentId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });
  }

  public fetchTranscript(resourceId: string) {
    const endpoint = `${this.resourceNamespace}/transcripts?resource_id=${resourceId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return contentSerializer.normalizeTranscript(response.data);
    });
  }

  /**
   * @return {Promise} fetch transcript for resources
   */

  public fetchSummary(resourceId: string) {
    const endpoint = `${this.resourceNamespace}/summary?resource_id=${resourceId}`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return contentSerializer.normalizeSummary(response.data);
    });
  }

  /**
   * Reads a grade list
   *
   * @returns {Promise}
   */
  public getGradeList() {
    const endpoint = `${window.location.origin}/${this.stubNamespace}/user-profile-grades.json`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });
  }

  public fetchPhraseCloud(resourceId: string) {
    const params = {
      resource_id: resourceId,
    };
    const endpoint = `${this.resourceNamespace}/phrasecloud`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return resourceSerializer.normalizePhrasecloud(response.data);
    }).catch(() => {
      return resourceSerializer.normalizePhrasecloud({});
    });
  }
}

export const contentAPI = ContentAPI.instance;
